import { useTranslation } from "react-i18next";
import ProposalContent from "../proposals/content";
import { money } from "../jobs/types";
import type { Review } from "./types";

export default function Content({
  review,
  headingTag = "h1",
}: {
  review: Review;
  headingTag?: "h1" | "h2" | "h3";
}) {
  const { t, i18n } = useTranslation();
  return (
    <div className="space-y-4">
      <ProposalContent
        representation={review.representation}
        title={t("billing_reviews.title")}
        locale={i18n.language}
        headingTag={headingTag}
      />
      <dl className="space-y-2 rounded-lg border p-4">
        {(
          [
            ["advance", review.advance_minor],
            ["due", review.amount_due_minor],
          ] as const
        ).map(([key, value]) => (
          <div key={key} className="flex flex-wrap justify-between gap-2">
            <dt>{t(`billing_reviews.${key}`)}</dt>
            <dd>
              {money(
                value,
                review.representation.total.currency,
                i18n.language,
              )}
            </dd>
          </div>
        ))}
      </dl>
      <p className="text-muted-foreground text-sm">
        {t("billing_reviews.advance_help")}
      </p>
      {review.increase && !["approved", "confirmed"].includes(review.state) && (
        <p role="status" className="rounded-lg border p-4">
          {t("billing_reviews.increase")}
        </p>
      )}
    </div>
  );
}
